import { createSelector } from 'reselect'
import { cartDocumentVerificationSelector, cartProductsSelector } from './cart'
import {
    removeAllProductThatCannotBeIrregular,
    removeAllProductsThatArentVendible
} from '../../utils/products'

export const homeSelector = (state) => state.home

export const homeErrorSelector = createSelector(
    homeSelector,
    (home) => home.error
)

export const homeLoadingSelector = createSelector(
    homeSelector,
    (home) => home.loading
)

export const homeProductsSelector = createSelector(
    homeSelector,
    (home) => home.products
)

export const homeProductModalSelector = createSelector(
    homeSelector,
    (home) => home.productModal
)

export const homeProductAliRefModalSelector = createSelector(
    homeSelector,
    (home) => home.aliRefModal
)

export const homeProductOthersModalSelector = createSelector(
    homeSelector,
    (home) => home.othersModal
)

export const homePatModalSelector = createSelector(
    homeSelector,
    (home) => home.patModal
)

export const homeOtherProductsSelector = createSelector(
    cartProductsSelector,
    homeProductsSelector,
    (cartProducts, homeProducts) =>
        cartProducts.reduce((result, cartProduct) => {
            return result.filter((product) => +product.code !== +cartProduct.id)
        }, homeProducts)
)

export const filterOtherProductsSelector = createSelector(
    homeOtherProductsSelector,
    cartDocumentVerificationSelector,
    (products, documentVerification) => {
        const otherProducts = []
            .reduce((result, product) => {
                return result.filter((p) => +p.code !== +product)
            }, products)
            .filter(removeAllProductsThatArentVendible)

        if (!documentVerification.valid)
            return otherProducts.filter(removeAllProductThatCannotBeIrregular)
        return otherProducts
    }
)
